var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-top": "10px" }
        },
        [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "50px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("common.btn.query") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "310px" },
                        attrs: {
                          no: "queryInput",
                          placeholder: _vm.$t("common.tips.fuzzyModelSearch")
                        },
                        model: {
                          value: _vm.filter.likeName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filter,
                              "likeName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "filter.likeName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "query", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "new", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "edit", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "delete", type: "danger" },
                  on: { click: _vm.remove }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-grid" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              no: "grid",
              "config-module": "1013010",
              "grid-params": _vm.girdParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-pagination" },
        [
          _c("cargo-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0"
              }
            ],
            attrs: {
              no: "pagination",
              "config-module": "1013010",
              total: _vm.total,
              page: _vm.filter.pageNum,
              limit: _vm.filter.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.filter, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.filter, "pageSize", $event)
              },
              pagination: _vm.toQuery
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "110px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      ref: "serialNumber",
                      attrs: {
                        valid: _vm.$t("FileHistory.PlsInput"),
                        label: _vm.$t(
                          "baseInfo.basicData.currency.serialNumber"
                        )
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "serialNumber",
                          disabled: "",
                          min: 0,
                          controls: false,
                          size: "mini"
                        },
                        on: { blur: _vm.serialNumberBlur },
                        model: {
                          value: _vm.editDialog.form.serialNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "serialNumber", $$v)
                          },
                          expression: "editDialog.form.serialNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      ref: "model",
                      attrs: {
                        valid: _vm.$t("FileHistory.PlsInput"),
                        label: _vm.$t("Pricing.Aircraft")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "model", disabled: _vm.isTenant },
                        model: {
                          value: _vm.editDialog.form.model,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "model", $$v)
                          },
                          expression: "editDialog.form.model"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      ref: "fullName",
                      attrs: {
                        valid: _vm.$t("FileHistory.PlsInput"),
                        label: _vm.$t("Pricing.AircraftFullName")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "fullName", disabled: _vm.isTenant },
                        model: {
                          value: _vm.editDialog.form.fullName,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "fullName", $$v)
                          },
                          expression: "editDialog.form.fullName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      ref: "type",
                      attrs: {
                        valid: _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                        label: _vm.$t("CargoMsg.Cargo_Type")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "type", disabled: _vm.isTenant },
                          model: {
                            value: _vm.editDialog.form.type,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "type", $$v)
                            },
                            expression: "editDialog.form.type"
                          }
                        },
                        _vm._l(_vm.airplaneModelTypes, function(item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.chineseName, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      ref: "totalVolume",
                      attrs: {
                        valid: _vm.$t("FileHistory.PlsInput"),
                        label: _vm.$t("SeaExport.TotalCubage")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "totalVolume",
                          disabled: _vm.isTenant,
                          controls: false
                        },
                        model: {
                          value: _vm.editDialog.form.totalVolume,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "totalVolume", $$v)
                          },
                          expression: "editDialog.form.totalVolume"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.TotalWeight2") + "(T)" }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "totalWeight",
                          disabled: _vm.isTenant,
                          controls: false
                        },
                        model: {
                          value: _vm.editDialog.form.totalWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "totalWeight", $$v)
                          },
                          expression: "editDialog.form.totalWeight"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("CargoMsg.Cargo_MaximumTakeOffWeight") + "(T)"
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "maxTakeoffWeight",
                          disabled: _vm.isTenant,
                          controls: false
                        },
                        model: {
                          value: _vm.editDialog.form.maxTakeoffWeight,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editDialog.form,
                              "maxTakeoffWeight",
                              $$v
                            )
                          },
                          expression: "editDialog.form.maxTakeoffWeight"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_NumberOfCartridges")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "containerCount",
                          disabled: _vm.isTenant,
                          precision: 0,
                          min: 0,
                          controls: false
                        },
                        model: {
                          value: _vm.editDialog.form.containerCount,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "containerCount", $$v)
                          },
                          expression: "editDialog.form.containerCount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      ref: "weightLimit",
                      attrs: {
                        valid: _vm.$t("FileHistory.PlsInput"),
                        label: _vm.$t("CargoMsg.Cargo_WeightRestrictions")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "weightLimit",
                          disabled: _vm.isTenant,
                          controls: false
                        },
                        model: {
                          value: _vm.editDialog.form.weightLimit,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "weightLimit", $$v)
                          },
                          expression: "editDialog.form.weightLimit"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      ref: "volumeLimit",
                      attrs: {
                        valid: _vm.$t("FileHistory.PlsInput"),
                        label: _vm.$t("CargoMsg.Cargo_VolumeLimit")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "volumeLimit",
                          disabled: _vm.isTenant,
                          controls: false
                        },
                        model: {
                          value: _vm.editDialog.form.volumeLimit,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "volumeLimit", $$v)
                          },
                          expression: "editDialog.form.volumeLimit"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.basicData.currency.remarks")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "remark", type: "textarea", rows: 3 },
                        model: {
                          value: _vm.editDialog.form.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remark", $$v)
                          },
                          expression: "editDialog.form.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "editSave", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "editCancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.platformDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_Add"),
            width: "950px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.platformDialog, "visible", $event)
            }
          }
        },
        [
          _c("base-airplane-model"),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.addFromPlatform }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.platformDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }